import React from 'react';
import { connect } from 'react-redux';
import { Button, message, Icon } from 'antd';
import { BrowserRouter as Router, Route, Switch, Redirect, NavLink, withRouter, Link } from 'react-router-dom';
import {getDuty} from "./actions";
const user = localStorage.getItem('HippoUserInfo') ? JSON.parse(localStorage.getItem('HippoUserInfo')) : null;

class Logo extends React.Component {
    constructor(props) {
        super(props);
    }
    logout = () => {
        localStorage.removeItem('HippoUserInfo');
        window.location = '/login';
    };
    componentDidMount() {
        if(user) {
            this.props.getDuty();
        }
    }
    render() {

        const uiDuty = this.props.uiDuty;

        let usrDuty = '';
        if(uiDuty!=undefined){
            usrDuty = uiDuty.usr.usr;
        }

        return user ? (
            <div style={{ float: 'right', color: '#fff' }}>
                <span >
                    今日值班人 : {usrDuty}
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="name" style={{ 'margin-top': '4px', 'font-size': '16px'}}>
                    <Icon type="user" />
                    {user.name}
                </span>
                <Button onClick={() => this.logout()} style={{ marginLeft: '10px' }}>
                    退出
                </Button>
            </div>
        ) : (
            <p style={{ float: 'right', color: '#fff' }}>未登录</p>
        );
    }
}

const mapStateToProps = state => ({
    uiDuty:state.login.uiDuty,
});

const mapDispatchToProps = dispatch => ({
    getDuty: () => dispatch(getDuty()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Logo));



// WEBPACK FOOTER //
// ./pages/login/Logo.js